import { hasSlotContent as e, removeClassStyleAttrs as t } from "../../common/utils/index.js";
import { CheckableMixin as n, GroupableMixin as r, InputMixin as i, MessagesMixin as a } from "../../common/mixins/input.js";
import { t as o } from "../../_plugin-vue_export-helper-BTgDAbhb.js";
import s from "../validation-messages/validation-messages.js";
import { TEXT_SIZE_MODIFIERS as c, TEXT_STRENGTH_MODIFIERS as l } from "../text/text-constants.js";
import u from "../text/text.js";
import { RADIO_INPUT_VALIDATION_CLASSES as d } from "./radio-constants.js";
import { createBlock as f, createCommentVNode as p, createElementBlock as m, createElementVNode as h, createTextVNode as g, createVNode as _, mergeProps as v, normalizeClass as y, normalizeStyle as b, openBlock as x, renderSlot as S, resolveComponent as C, toDisplayString as w, toHandlers as T, withCtx as E } from "vue";
//#region components/radio/radio.vue
var D = {
	compatConfig: { MODE: 3 },
	name: "DtRadio",
	components: {
		DtValidationMessages: s,
		DtText: u
	},
	mixins: [
		i,
		n,
		r,
		a
	],
	inheritAttrs: !1,
	props: {
		value: {
			type: [String, Number],
			default: ""
		},
		showLabel: {
			type: Boolean,
			default: !0
		},
		labelSize: {
			type: [String, Number],
			default: null,
			validator: (e) => c.label.includes(String(e))
		},
		labelStrength: {
			type: String,
			default: null,
			validator: (e) => Object.keys(l).includes(e)
		}
	},
	emits: [
		"update:modelValue",
		"focus",
		"focusin",
		"focusout"
	],
	data() {
		return { hasSlotContent: e };
	},
	computed: {
		hasLabelContent() {
			return !!(this.$slots.default || this.label);
		},
		hasLabel() {
			return this.showLabel && this.hasLabelContent;
		},
		resolvedLabelSize() {
			return this.labelSize ?? 300;
		},
		inputValidationClass() {
			return d[this.internalValidationState];
		},
		radioGroupValue() {
			return this.groupContext?.selectedValue;
		},
		inputListeners() {
			return {
				input: () => {},
				focusin: (e) => this.$emit("focusin", e),
				focusout: (e) => this.$emit("focusout", e),
				change: (e) => this.emitValue(e.target.value)
			};
		},
		hasMessages() {
			return this.formattedMessages.length && this.showMessages;
		}
	},
	watch: { radioGroupValue: {
		immediate: !0,
		handler(e) {
			this.hasGroup && (this.internalChecked = e === this.value);
		}
	} },
	mounted() {
		this.runValidations();
	},
	methods: {
		removeClassStyleAttrs: t,
		runValidations() {
			!this.hasLabelContent && !this.$attrs["aria-label"] && console.info("[Dialtone] A label is required for accessibility. Provide a label prop and use show-label=\"false\" to hide it visually.");
		},
		emitValue(e) {
			e !== this.radioGroupValue && (this.setGroupValue(e), this.$emit("update:modelValue", e));
		}
	}
}, O = { class: "d-radio__input" }, k = [
	"checked",
	"name",
	"value",
	"disabled",
	"aria-label"
], A = {
	key: 0,
	class: "d-radio__messages",
	"data-qa": "radio-description-messages"
};
function j(e, t, n, r, i, a) {
	let o = C("dt-text"), s = C("dt-validation-messages");
	return x(), m("div", {
		class: y(e.$attrs.class),
		style: b(e.$attrs.style)
	}, [h("label", { class: y(["d-radio-group", { "d-radio-group--disabled": e.internalDisabled }]) }, [h("div", O, [h("input", v({
		checked: e.internalChecked,
		name: e.internalName,
		value: n.value,
		disabled: e.internalDisabled,
		type: "radio",
		class: [
			"d-radio",
			a.inputValidationClass,
			e.inputClass
		],
		"aria-label": !n.showLabel && e.label ? e.label : void 0
	}, a.removeClassStyleAttrs(e.$attrs), T(a.inputListeners, !0)), null, 16, k)]), a.hasLabel ? (x(), f(o, v({
		key: 0,
		as: "div",
		kind: "label",
		size: a.resolvedLabelSize,
		strength: n.labelStrength ?? "normal",
		tone: e.internalDisabled ? "disabled" : "primary",
		class: [e.labelClass, "d-radio__copy d-radio__label"]
	}, e.labelChildProps, { "data-qa": "radio-label" }), {
		default: E(() => [S(e.$slots, "default", {}, () => [g(w(e.label), 1)])]),
		_: 3
	}, 16, [
		"size",
		"strength",
		"tone",
		"class"
	])) : p("", !0)], 2), e.$slots.description || e.description || a.hasMessages ? (x(), m("div", A, [e.$slots.description || e.description ? (x(), f(o, v({
		key: 0,
		kind: "body",
		size: 200,
		tone: "tertiary",
		as: "div",
		class: ["d-description", e.descriptionClass]
	}, e.descriptionChildProps, { "data-qa": "radio-description" }), {
		default: E(() => [S(e.$slots, "description", {}, () => [g(w(e.description), 1)])]),
		_: 3
	}, 16, ["class"])) : p("", !0), _(s, v({
		"validation-messages": e.formattedMessages,
		"show-messages": e.showMessages,
		class: e.messagesClass
	}, e.messagesChildProps, { "data-qa": "dt-radio-validation-messages" }), null, 16, [
		"validation-messages",
		"show-messages",
		"class"
	])])) : p("", !0)], 6);
}
var M = /* @__PURE__ */ o(D, [["render", j]]);
//#endregion
export { M as default };

//# sourceMappingURL=radio.js.map